/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 var velScroll=0.75;
 var scrollTop ;
 var barraOrange = true;
 var altMenu;
 var abroFancy =false;
 var swiper;

 var lang;

 var arrPreguntas;

(function($) {



    function igualaAlturas(_itm){

    $(_itm).css('height','initial');
    var altMax=0;
    $(_itm).each(function(i){

       console.log($(this).parent().attr('class')+" >>> "+$(this).height() );

      altMax = Math.max(altMax, $(this).height() );      
    });

      console.log(altMax);

    $(_itm).height(altMax);

  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function(){


        lang = $('html').attr('lang');

 


        //MENU BOTONO PLAY

        $('.play_time').on("click", function(){
            var fallaGif = $(this).parents('.slide_falla').find('.img_falla_slide').data('gif');
            var fallaOri = $(this).parents('.slide_falla').find('.img_falla_slide').data('original');

            //alert(fallaGif);
            

            if(!$(this).hasClass("in_play")){
              $(this).find('img').attr('src', $(this).data('pause') );
              $(this).parents('.slide_falla').find('.img_falla_slide').attr('src', fallaGif);
              swiper.stopAutoplay();
            }else{
              $(this).find('img').attr('src', $(this).data('play') );
              $(this).parents('.slide_falla').find('.img_falla_slide').attr('src', fallaOri);
              swiper.startAutoplay();
            }

            $(this).toggleClass("in_play");



        });


        $('.menu_resp').click(function(event){
            event.preventDefault(); 
           $('.menu_header').slideToggle();
           $('.menu_resp').toggleClass('menu_header_open');
        });

        
        // $('.menu_header').slideToggle();

        altMenu = $('.menu_true').outerHeight(true);


        //
       // wheelzoom(document.querySelector('.img_falla_slide'));


        //SHARES BAIX

        $('.sh_b_twi').on('click',function(event){
          event.preventDefault(); 
          share_tw('url');




        });

        $('.sh_b_fb').on('click',function(event){
          event.preventDefault();
          share_fb('url');

       
        });
 

 
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

        setTimeout(function(){  
 

                

            }, 3000);


      }
    } ,
    // About us page, note the change from about-us to about_us.
    'home': {
      init: function() {
        // JavaScript to be fired on the about us page
       // $('.zoom_uno').removeClass('zoom_uno');
       // alert("CAJA");





/////////////////RECARGO IMAGEN FALLAS

//img_falla_slide

            function recargaFalla(){

               $('.img_falla_slide').each(function(i){
                  $(this).attr('src', $(this).attr('src') );
               });

 
             // $('.img_falla_slide').attr('src', 'http://hackathon-in-a-box.org/img/box.png' );
 
            }

            var fallaTimer = setInterval(recargaFalla, 5000);


 

      if($(window).width() > $(window).height() ){   

          $('.visor_fallas').height($(window).height() - $('.header').outerHeight(true) - 20 );

      }else{

 

      }

 

 ///////////////MENU RESPONSIVE

 



////////////////QUE LI DIUS A LA FALLA


 


            switch (lang){

              case "es":
                    arrPreguntas= new Array(
                    "¿Qué estás haciendo?", 
                    "¿Qué te has comprado?", 
                    "¿Qué te estás tomando?", 
                    "¿Cómo te sientes?",
                    "¿Qué estás comiendo?", 
                    "¿Qué horas se te han hecho?", 
                    "¿Qué te gusta?",
                    "¿Qué marcha me llevas?", 
                    "¿Con quién estás?", 
                    "¿Qué música escuchas?", 
                    "¿Qué estás viendo?", 
                    "¿Por dónde andas?", 
                    "¿Qué llevas puesto?", 
                    "¿Cómo vas?",
                    "Ola, ¿k ase?",
                    "¿Con qué emoticono te identificas?",
                    "¿Cómo son las fallas en emoticonos?",
                    "¿Un emoticono para la falla infantil?");
              break;

              case "en":
                    arrPreguntas= new Array(
                    "What are you looking at?", 
                    "What are you doing?", 
                    "What are you drinking?", 
                    "What are you eating?",
                    "How would you describe the Falles using emoticons?", 
                    "What emoticons better describe you?", 
                    "Would you share an emoticon with the Falla Infantil?", 
                    "How are you feeling?",  
                    "Where are you going?", 
                    "What are you wearing?", 
                    "What do you like the most?", 
                    "What music are you listening to?",
                    "Who are you with?",
                    "What have you bought lately?" );
              break;

              default:
                    arrPreguntas= new Array(
                    "Què estàs fent?", 
                    "Què t'has comprat?", 
                    "Què t'estàs prenent?", 
                    "Com te sents?",
                    "Què menges?", 
                    "Quines hores se t'han fet?", 
                    "Què t'agrada?", 
                    "Amb qui estàs?", 
                    "Quina música escoltes?", 
                    "Què estàs veient?", 
                    "Per a on pares?", 
                    "Què dus?", 
                    "Com vas?",
                    "Amb quina emoticona t'identifiques?",
                    "Com són Les Falles en emoticones?",
                    "Tens ganes de comboi?",
                    "Una emoticona per a la falla infantil?");
              break;

            }




            var preg;
            var prePreg=0;
            var ranPreg=0;



            function cambiaPregunta(){

              do{
                ranPreg = Math.floor( Math.random()*arrPreguntas.length );
              }while(ranPreg===prePreg);
                
              preg = arrPreguntas[ranPreg];

              $('.quelidius').fadeOut(300, function(){
                  $('.quelidius').text(preg);
                  $('.quelidius').fadeIn(300);
              });

              prePreg = ranPreg;


///////////////QUE LI DIUS A LA FALLA

 
            }

            var pregTimer = setInterval(cambiaPregunta, 5000);

           // $('.quelidius')


           $('.sec_faqs').css('display','none');


           $('.saber_mas a, .boca_saber').click(function(event){
            event.preventDefault();
            $('.sec_faqs').slideToggle(400);
           });
 
          igualaAlturas($('.nom_falla_down'));



 

      $('.hashtag h1').css({

        top :$('.swi_der').offset().top - $('.swi_der').height() // $('.swiper_fallas').height()/2  + $('.alt_menu').height() 
      });



////////////////SWIPER


        // JavaScript to be fired on all pages
        swiper = new Swiper('.visor_fallas',{
          speed:750, 
          nextButton:'.swi_der', 
          prevButton:'.swi_izq' ,
          autoplay:'5000',  
          loop:'true',

          preventClicksPropagation:true
            });
         var TweenSlide;

         function _inicioSwiper(ev){
 
         }

         function _finSwiper(ev){ 

          $('.swiper-slide-active .img_falla_slide').addClass('zoom_uno');
        //  alert("FIN");
         }

         swiper.on('onSlideChangeStart',  _inicioSwiper );
         swiper.on('onSlideChangeEnd',  _finSwiper );/* */




          var swiperBoca = new Swiper('.swiper_bocadillo',{
          speed:750  ,
          autoplay:'7000',  
          loop:'true',
          effect: 'fade',
          autoplayDisableOnInteraction:'false',
          fade: { crossFade: true }  });




         swiperBoca.on('onSlideChangeStart',  _inicioSwiperBoca ); 

         function _inicioSwiperBoca(swiper){


          var n = $('.slide-boc').index($('.slide-boc.swiper-slide-active  '))  ;

          console.log(n%2);

          if(n%2===0){

            $('.pico_izq').fadeIn();
            $('.pico_der').fadeOut(); 

          }else{

            $('.pico_der').fadeIn();
            $('.pico_izq').fadeOut();

          } 

         }



//////////////TWITTER

         $('.alt_menu').height( $('.header').height() );
         $('.cont_twi').css('top',  $('.header').height() );

         var data  = "https://api.twitter.com/1.1/statuses/user_timeline.json?screen_name=twitterapi&count=2&retweeted=false";//
         var json = $.getJSON(data);//

         function hazTwitter(){

            $('.twi_der').twittie({ 
                'hashtag': "fallaimmaterial",
                'count':5,
                'hideReplies':true,
                'template':'{{tweet}}'
            }, function() {
 

              $('.twi_der').css('min-height', $('.twi_der ul').outerHeight(true));
     
            });


         }

         hazTwitter();
 
         var pregTimer = setInterval(hazTwitter, 120000);

//////////////TWITTER



////////////MENU


      $('.menu_header > li > a:not(.sel_idiomas),  .brand_home,   .link_interior').click(function(event){
        event.preventDefault();
        var goTo = $(this).attr('href');

       // alert( $('.menu_true').outerHeight(true)   );

        goTo = $(goTo).offset().top  - altMenu;// - $('.menu_true').outerHeight(true)  ;
        TweenLite.to(window, velScroll, {scrollTo:goTo});

        if ($('.menu_resp').hasClass('menu_header_open')){

            $('.menu_header').slideUp();
            $('.menu_header_open').toggleClass('menu_header_open');

        }


      });

      $('.sel_idiomas').click(function(event){
        event.preventDefault();
        $('.menu_lang').slideToggle(300);


      });



////////////SCROLL

/**/

$(window).scroll(function(ev){             

          var py = (   $('.hashtag h1').height()/2 ) - 1* ($(window).scrollTop() / 10) +"px" ;
          var px =  -1* $('.hashtag h1').width()/2 +"px"; 
 

          $('.hashtag h1').css({
            transform : "translate3d("+px +" , " + py + " , 0px)"
          }); 

        var ty =   - 1* ($(window).scrollTop() / 5) +"px"  ;

          $('.cont_twi').css({
            transform : "translate3d(0px, " + ty + " , 0px)"
          });  


          scrollTop = window.pageYOffset; 

          if(barraOrange==true){ 

              if(scrollTop > $('.menu_up').height()){
                //alert("PUJE!")
                $('.menu_up').stop().slideUp(200);
                barraOrange =false;


              }

          }

          if(barraOrange==false){ 

              if(scrollTop < $('.menu_up').height()){
                //alert("PUJE!")
                $('.menu_up').stop().slideDown(200);
                barraOrange =true;


              }

          } 
});         


/////////////////

 

      $(".fancybox").click(function(event){
        event.preventDefault(); 

       // $(this).trigger( "click" );

            abroFancy =true;


            $.fancybox.open([
          {
              href : this.href,
              afterLoad: function(){
  
                //wheelzoom($('.fancybox-image'));

                setTimeout(function(){  wheelzoom($('.fancybox-image'))    }, 100);

                //$("html").getNiceScroll().enablemousewheel(false);

                  $("html").getNiceScroll().remove();

                    var rueda = $('.userueda').clone();
                    $('.fancybox-inner').append(rueda);
                    $('.userueda').fadeIn() ;
                    setTimeout(function(){  $('.userueda').fadeOut()    }, 2500);


              }
              ,
              afterClose: function(){


                  $("html").niceScroll({cursorcolor:"#ef4d2d", cursorwidth:"10", autohidemode:"false", zindex :"100000000", background:"#ffffff"  });   
                  abroFancy = false;
              }
        
          }    
            ], {
                padding : 0   
            });



      });


          $('.bot_image').click(function(event){
            event.preventDefault();

            $(this).next().find('.fancybox').trigger( "click" );

              });






        //DESACTIVO NICESCROLL


              $(window).bind('mousewheel DOMMouseScroll', function(event){

 

              });



  

      if((navigator.userAgent.indexOf('iPad')===-1) &&  (navigator.userAgent.indexOf('iPhone')===-1)   &&  (navigator.userAgent.indexOf('Android')===-1)   ){

           // $(".zb").zbox( { margin:10 } );

            ///////////////NICESCROLL      
           $("html").niceScroll({cursorcolor:"#ef4d2d", cursorwidth:"10", autohidemode:"false", zindex :"100000000", background:"#ffffff"  });    
        


      }else{ 

 

        
 
        /*
          $('.bot_image').click(function(event){
            event.preventDefault();

            $(this).next().find('.fancybox').trigger( "click" );

              });

*/

          //$(".fancybox").fancybox();

      }



 
 
////////////////FIN LUPA

      }
    } 
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {

    

      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {

      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

 

      //ARREGLO ICONOS SHARE

      
      //$('.st_facebook_large').find('.stLarge').css({'background-image:url(../images/ico_fb.svg)'})


    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

$( window ).load(function() {

  var assets = $('body').data("assets");

  if(assets.indexOf('.php')!=-1 ){



    assets = assets.substring(0, assets.lastIndexOf("/")+1 );

 


  }
  // Run code
  //alert( $('.st_facebook_large').find('.stLarge').length);
  /*
  $('.st_facebook_large').find('.stLarge').css({"background-image":"url("+assets+"dist/images/ico_fb.svg)"});
  $('.st_twitter_large').find('.stLarge').css({"background-image":"url("+assets+"dist/images/ico_twi.svg)"});
  $('.st_pinterest_large').find('.stLarge').css({"background-image":"url("+assets+"dist/images/ico_pin.svg)"});
  $('.st_email_large').find('.stLarge').css({"background-image":"url("+assets+"dist/images/ico_mail.svg)"});
  $('.st_sharethis_large').find('.stLarge').css({"background-image":"url("+assets+"dist/images/ico_share.svg)"});
  */





  //ico_pin

 

  igualaAlturas($('.nom_falla'));





});
 